import { createTheme } from '@mui/material/styles';

export const dashboardTheme = createTheme({
  palette: {
    primary: { main: '#1D70B8', contrastText: '#FFFFFF' },
    secondary: { main: '#F7996A', contrastText: '#0B0C0C' },
    background: { default: '#F4F8FB', paper: '#FFFFFF' },
    text: { primary: '#0B0C0C', secondary: '#484949' },
    divider: '#CECECE',
    info: { main: '#158187' },
    warning: { main: '#F47738' },
    error: { main: '#CA3535' },
    success: { main: '#0F7A52' },
  },
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h3: { color: '#0B0C0C', fontWeight: 700 },
    h5: { color: '#0B0C0C', fontWeight: 650 },
  },
  shape: { borderRadius: 6 },
  components: {
    MuiCard: { styleOverrides: { root: { border: '1px solid #CECECE', boxShadow: '0 2px 8px rgba(11, 12, 12, 0.08)' } } },
    MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 700 } } },
  },
});
